export default __webpack_public_path__ + "static/brightHealth-3f863a68c0a895895d718261307ec0f2.svg";